/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-02 10:18:03
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-08-18 13:07:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCurrency/constant.ts
 */
export type SalesChannelCurrencyItem = {
  uuid?: string;
  currencyCode: string;
  currencyName: string;
  showSecondary: boolean;
  secondaryCurrencyCode?: string;
  secondaryCurrencyName?: string;
  conversionMode?: Cnversion;
  roundingRule?: RoundingRule | string;
  truncateRule?: TruncateRule;
  decimalPosition: number;
  decimalSeparator: DecimalSeparator | string;
  thousandsSeparator: ThousandsSeparator | string;
  currencySymbol: string;
  currencySymbolList?: Array<string>;
  currencyDisplayFormat: DisplayFormat | string;
  secondaryCurrencySymbol?: string;
  secondaryCurrencyDisplayFormat?: DisplayFormat;
  referenceDecimalPosition?: number;
  referenceConversionMode?: Cnversion;
  referenceRoundingRule?: RoundingRule | string;
  referenceTruncateRule?: TruncateRule;
  referenceDecimalSeparator?: DecimalSeparator | string;
  referenceThousandsSeparator?: ThousandsSeparator | string;
  primary?: boolean;
  salesChannelUuid: string;
  deleted?: boolean;
};
export type SalesChannelCurrencyConfig = SalesChannelCurrencyItem[];

export enum Cnversion {
  Round = 'Round',
  Truncate = 'Truncate',
}

export enum RoundingRule {
  UP = 'UP',
  DOWN = 'DOWN',
  CEILING = 'CEILING',
  FLOOR = 'FLOOR',
  HALF_UP = 'HALF_UP',
  HALF_DOWN = 'HALF_DOWN',
  HALF_EVEN = 'HALF_EVEN',
  UNNECESSARY = 'UNNECESSARY',
}

export enum TruncateRule {
  WHOLE_NUMBERS = 'WHOLE_NUMBERS',
  TENTHS = 'TENTHS',
  HUNDREDTHS = 'HUNDREDTHS',
  THOUSANDTHS = 'THOUSANDTHS',
  TEN_THOUSANDTHS = 'TEN_THOUSANDTHS',
  HUNDRED_THOUSANDTHS = 'HUNDRED_THOUSANDTHS',
  MILLIONTHS = 'MILLIONTHS',
  TEN_MILLIONTHS = 'TEN_MILLIONTHS',
  HUNDRED_MILLIONTHS = 'HUNDRED_MILLIONTHS',
  BILLIONS = 'BILLIONS',
}

export enum DecimalSeparator {
  POINT = 'POINT',
  COMMA = 'COMMA',
}

export enum ThousandsSeparator {
  NOT_USE = 'NOT_USE',
  COMMA = 'COMMA',
  POINT = 'POINT',
  SPACE = 'SPACE',
}

export enum DisplayFormat {
  PREFIX_AMOUNT = 'PREFIX_AMOUNT',
  AMOUNT_SUFFIX = 'AMOUNT_SUFFIX',
}

export const decimalPositionOptions = [
  { label: 0, value: 0 },
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
  { label: 8, value: 8 },
  { label: 9, value: 9 },
];

export const conversionOptions = ({ getI18n }) => [
  {
    label: getI18n('salesChannelCurrency.index.wHOLE_NUMBERS'),
    value: 'WHOLE_NUMBERS',
    index: 1,
  },
  {
    label: getI18n('salesChannelCurrency.index.tENTHS'),
    value: 'TENTHS',
    index: 2,
  },
  {
    label: getI18n('salesChannelCurrency.index.hUNDREDTHS'),
    value: 'HUNDREDTHS',
    index: 3,
  },
  {
    label: getI18n('salesChannelCurrency.index.tHOUSANDTHS'),
    value: 'THOUSANDTHS',
    index: 4,
  },
  {
    label: getI18n('salesChannelCurrency.index.tEN_THOUSANDTHS'),
    value: 'TEN_THOUSANDTHS',
    index: 5,
  },
  {
    label: getI18n('salesChannelCurrency.index.hUNDRED_THOUSANDTHS'),
    value: 'HUNDRED_THOUSANDTHS',
    index: 6,
  },
  {
    label: getI18n('salesChannelCurrency.index.mILLIONTHS'),
    value: 'MILLIONTHS',
    index: 7,
  },
  {
    label: getI18n('salesChannelCurrency.index.tEN_MILLIONTHS'),
    value: 'TEN_MILLIONTHS',
    index: 8,
  },
  {
    label: getI18n('salesChannelCurrency.index.hUNDRED_MILLIONTHS'),
    value: 'HUNDRED_MILLIONTHS',
    index: 9,
  },
  {
    label: getI18n('salesChannelCurrency.index.bILLIONS'),
    value: 'BILLIONS',
    index: 10,
  },
];

export const ruleStartPosition = (rule: string) => {
  switch (rule) {
    case TruncateRule.WHOLE_NUMBERS:
      return 0;
    case TruncateRule.TENTHS:
      return 1;
    case TruncateRule.HUNDREDTHS:
      return 2;
    case TruncateRule.THOUSANDTHS:
      return 3;
    case TruncateRule.TEN_THOUSANDTHS:
      return 4;
    case TruncateRule.HUNDRED_THOUSANDTHS:
      return 5;
    case TruncateRule.MILLIONTHS:
      return 6;
    case TruncateRule.TEN_MILLIONTHS:
      return 7;
    case TruncateRule.HUNDRED_MILLIONTHS:
      return 8;
    case TruncateRule.BILLIONS:
      return 9;
  }
};
